import { ResolveTypes, Transition } from "@uirouter/react";
import { includes } from "lodash";
import { MenuNode, MenuRoute } from "../../components/menu";
import { store } from "../../store";
import { LeafRole, Or } from "../../utils/and-or-tree";
import { ShellRouteNames } from "../shell/route-names";
import { ParticipationsComponent } from "./all";
import { ParticipationList } from "./all/results";
import { ParticipationDetail } from "./detail";
import { ParticipationDetailForm } from "./detail-form";

const names = {
  all: `${ShellRouteNames.shell}.participations-all`,
  single: `${ShellRouteNames.shell}.participations-single`,
  singleForm: `${ShellRouteNames.shell}.participations-single-form`,
  ownAll: `${ShellRouteNames.shell}.own-participations-all`,
};

const detailPageResolved: ResolveTypes[] = [
  {
    token: "id",
    policy: { when: "EAGER" },
    deps: [Transition],
    resolveFn: (trans: Transition) => trans.params().id,
  },
];

const states: MenuRoute[] = [
  {
    name: names.all,
    component: ParticipationsComponent,
    url: "/participations",
    data: {
      title: "onboarded-individuals",
      roles: new Or(
        new LeafRole("ROLE_ADMIN"),
        new LeafRole("ROLE_COMMUNITY_MANAGER"),
        new LeafRole("ROLE_MERCHANT")
      ),
    },
    resolve: [
      {
        token: "isMerchant",
        resolveFn: () => {
          const token = store.getState().auth.login;
          return (
            token.status === "ready" &&
            includes(token.data.accessToken.roles, "ROLE_MERCHANT") &&
            !(
              token.data.accessToken.submerchantIds &&
              token.data.accessToken.submerchantIds.length > 0
            )
          );
        },
      },
      {
        token: "hideName",
        deps: [Transition],
        resolveFn: async (trans: Transition) => {
          const val = await trans.injector().getAsync("isMerchant");
          return !val;
        },
      },
    ],
  },
  {
    name: names.ownAll, // TODO:
    url: "/my-onboarded-projects",
    component: ParticipationList,
    data: {
      title: "my-onboarded-projects",
      roles: new LeafRole("ROLE_USER"),
    },
    resolve: [
      {
        token: "hideEmail",
        resolveFn: () => true,
      },
      {
        token: "hideName",
        resolveFn: () => true,
      },
      {
        token: "hideViewKyc",
        resolveFn: () => true,
      },
    ],
  },
  {
    name: names.single,
    component: ParticipationDetail,
    url: "/participations/:id",
    data: {
      title: "participation-detail",
    },
    params: {
      id: {
        type: "string",
      },
    },
    resolve: detailPageResolved,
    redirectTo: async (trans: Transition) => {
      const token = store.getState().auth.login;
      if (
        token.status === "ready" &&
        (includes(token.data.accessToken.roles, "ROLE_ADMIN") ||
          includes(token.data.accessToken.roles, "ROLE_COMMUNITY_MANAGER"))
      ) {
        return trans.router.stateService.target(
          names.singleForm,
          trans.params(),
          trans.options()
        );
      }
    },
  },
  {
    name: names.singleForm,
    url: "/participations/:id",
    component: ParticipationDetailForm,
    data: {
      title: "participation-detail",
    },
    params: {
      id: {
        type: "string",
      },
    },
    resolve: detailPageResolved,
  },
];

export const adminSidebar: MenuNode.MenuNode = {
  icon: "participations",
  route: states[0],
  roles: new Or(
    new LeafRole("ROLE_ADMIN"),
    new LeafRole("ROLE_COMMUNITY_MANAGER"),
    new LeafRole("ROLE_MERCHANT")
  ),
};

export const defaultSidebar: MenuNode.MenuNode = {
  icon: "participations",
  route: states[1],
  roles: new LeafRole("ROLE_USER"),
};

export const ParticipationsRoutes = {
  names,
  states,
  adminSidebar,
  defaultSidebar,
};
